import React from "react";
import { Row, Col } from "antd";
import { colors } from "../utils/colors";
import NormandyLogo from "../../../assets/Normandy-no-small-text-white.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div style={{ background: colors.primaryGreen, borderTop: "1px solid #213e7c" }}>
      {/*
        body_content_margins: max-width 1100px, margin auto, padding 40px 10px
        w-layout-layout (grid): adds padding 20px inside
        Combined: 40+20=60px top/bottom, 10+20=30px left/right
      */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "60px 30px" }}>
        <Row justify="space-between">

          {/* Left cell — w-layout-cell: flex column, align-items flex-start */}
          <Col xs={24} md={12}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              {/* Logo */}
              <a href="https://www.normandyins.com/index.html" target="_blank" rel="noreferrer" style={{ display: "inline-block" }}>
                <img src={NormandyLogo} alt="Normandy Insurance logo" width={214} style={{ display: "block" }} />
              </a>
              {/* space_x-small: 25px spacer */}
              <div style={{ height: 25 }} />
              {/* Phone — fa-phone solid, font-size 16px, line-height 24px, margin-bottom 10px */}
              <p style={{ margin: "0 0 10px 0" }}>
                <a href="tel:+18666886442" style={{ color: colors.white, fontSize: 16, lineHeight: "24px", textDecoration: "none" }}>
                  <i className="fa-solid fa-phone" style={{ fontSize: 16, marginRight: 6 }} />
                  866-688-6442
                </a>
              </p>
              {/* Email — fa-envelope solid, font-size 16px, line-height 24px */}
              <p style={{ margin: 0 }}>
                <a href="mailto:info@normandyins.com" style={{ color: colors.white, fontSize: 16, lineHeight: "24px", textDecoration: "none" }}>
                  <i className="fa-solid fa-envelope" style={{ fontSize: 16, marginRight: 6 }} />
                  info@normandyins.com
                </a>
              </p>
            </div>
          </Col>

          {/* Right cell — text_align_right: text-align right, align-self flex-end */}
          <Col xs={24} md={12} className="footer-right-col">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>

              {/* Social icons — fa-brands, same as platform's icon_fontawesome_brand + w-button style */}
              <div>
                <a
                  href="https://www.facebook.com/normandyins/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-btn"
                >
                  <i className="fa-brands fa-facebook-f" />
                </a>
                <a
                  href="https://www.linkedin.com/company/normandyins/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-btn"
                >
                  <i className="fa-brands fa-linkedin-in" />
                </a>
                <a
                  href="https://www.instagram.com/normandy_ins/?hl=en"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-btn"
                >
                  <i className="fa-brands fa-instagram" />
                </a>
              </div>

              {/* Copyright + Links — text_x-small: 12px/20px, padding-top 12px, same <p> block as platform */}
              <p className="footer-copyright">
                Copyright &copy; {currentYear}.&nbsp;&nbsp;All Rights Reserved<br />
                <a href="https://www.normandyins.com/sitemap.html" target="_blank" rel="noreferrer" className="footer-link-white">Sitemap</a>
                <span> | </span>
                <a href="https://www.normandyins.com/terms-and-conditions.html" target="_blank" rel="noreferrer" className="footer-link-white">Terms &amp; Conditions</a>
                <span> | </span>
                <a href="https://www.normandyins.com/privacy-policy.html" target="_blank" rel="noreferrer" className="footer-link-white">Privacy Policy</a>
              </p>

            </div>
          </Col>

        </Row>
      </div>
    </div>
  );
}
